import React from 'react'

// local components
import EditButton from './EditButton'
import RemoveButton from './RemoveButton'
import Sessions from './Sessions'

// shared components
import PersonCard from 'components/shared/PersonCard'
import CamperStatus from 'components/account/CamperStatus'

// containers
import DeleteCamperModal from './DeleteCamperModal'

export default function Camper(props) {
  const { camper, reupRequired, setModal, editable, account } = props
  const { camperSessions } = camper

  return (
    <PersonCard
      header={
        <CamperStatus
          camper={camper}
          reupRequired={reupRequired}
          account={account}
        />
      }
      desktopButtons={
        editable ? (
          <>
            <EditButton
              align='right'
              camper={camper}
              reupRequired={reupRequired}
            />
            <RemoveButton align='right' camper={camper} setModal={setModal} />
          </>
        ) : null
      }
      mobileButtons={
        editable ? (
          <>
            <EditButton camper={camper} reupRequired={reupRequired} />
            <RemoveButton camper={camper} setModal={setModal} />
          </>
        ) : null
      }
    >
      <DeleteCamperModal camper={camper} />
      <Sessions camper={camper} camperSessions={camperSessions} />
    </PersonCard>
  )
}
